module.exports = __webpack_public_path__ + "img/ycy-cy-3.79474cff.png";